<!--
File: menu.component.html
Project: catalog-cloud
File Created: Wednesday, 22nd December 2021 12:48:17
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Thursday, 31st October 2024 9:31:29 am
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<p-menubar
  *ngIf="itemsLoaded"
  [model]="menuitems"
  [styleClass]="'border-none bg-white topbar-menu'"
>
</p-menubar>
